module.exports = __webpack_public_path__ + "static/media/home_medical2.af58b897.jpg";